import React, { Component } from 'react';
import { connect } from 'react-redux';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS } from 'src/constants/EndpointUrls';
import { setList, getList } from 'src/reducers/common/editableListReducer';
import { REDUCER_NAME } from 'src/reducers/clients/allowedIps';
import EditableListButtons from './components/EditableListButtons';
import EditableListFormed from './components/EditableListFormed';
import { withTranslation } from 'react-i18next';

class AllowedIpList extends Component {
  componentWillMount() {
    const { allowedIps, dispatch } = this.props;
    dispatch(setList(REDUCER_NAME, allowedIps));
  }

  render() {
    const { ipList } = this.props;

    return (
      <div>
        <div className="l-main-title-wrap">
          <h1 className="m-title-main">{this.props.t('features.ClientAllowedIpSetting.AllowedIpList.IP_address_restriction')}</h1>
          <p className="m-title-main-note">{this.props.t('features.ClientAllowedIpSetting.AllowedIpList.You_will_not_be_able_to_access_from_other_than_the_registered_IP_address')}</p>
        </div>
        <div className="l-wrap-xs l-contents-wrap">
          <div className="u-mb20">
            <BreadCrumb>
              <BreadCrumb.Item label={this.props.t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
              <BreadCrumb.Item label={this.props.t('features.ClientAllowedIpSetting.AllowedIpList.IP_address_restriction')} />
            </BreadCrumb>
          </div>
          <div>
            <EditableListButtons ipList={ipList} />
            <EditableListFormed />
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation('translation')(connect(state => ({
  ipList: getList(REDUCER_NAME, state)
}))(AllowedIpList));
